/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Zalify has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/* OKWD sitefix 2026-06-18 browser fallback */
(function () {
  function isJapanesePage() {
    return location.pathname.indexOf('/ja-jp') === 0 ||
      document.documentElement.lang.toLowerCase().indexOf('ja') === 0 ||
      (window.Shopify && window.Shopify.locale === 'ja');
  }

  function replaceHtml(root, from, to) {
    if (!root || root.innerHTML.indexOf(from) === -1) return;
    root.innerHTML = root.innerHTML.split(from).join(to);
  }

  function normalizeJapaneseCopy() {
    if (!isJapanesePage()) return;

    document.querySelectorAll('h4').forEach(function (node) {
      if (node.textContent.trim() === '日本・米国送料無料') {
        node.textContent = '日本国内送料無料';
        var text = node.parentElement && node.parentElement.querySelector('p');
        if (text && text.textContent.indexOf('15〜25') !== -1) {
          text.textContent = '日本国内のご注文は送料無料、最低購入金額なし。15 営業日でお届け。';
        }
      }
    });

    document.querySelectorAll('.okwd-faq__a').forEach(function (node) {
      replaceHtml(
        node,
        'ご注文後 <strong>1〜3 営業日</strong> で発送し、<strong>15〜25 営業日</strong> でお届けいたします。',
        'ご注文後 <strong>1〜3 営業日</strong> で発送し、配送は <strong>15 営業日</strong> が目安です。'
      );
      replaceHtml(
        node,
        '日本国内および米国向けのご注文は送料無料',
        '日本国内のご注文は送料無料'
      );
    });

    var policy = document.querySelector('.shopify-policy__body');
    if (policy) {
      [
        ['本ポリシーは、アメリカ合衆国からのご注文に適用されます。', '本ポリシーは、日本国内へのご注文に適用されます。'],
        ['アメリカ合衆国全土に、迅速かつ確実な', '日本国内のご注文は、迅速かつ確実な'],
        ['標準配送 無料 — 全てのご注文が対象です。', '標準配送無料 — 日本国内の全てのご注文が対象です。'],
        ['配送期間：</b></span>15〜25営業日', '配送期間：</b></span>15営業日']
      ].forEach(function (pair) {
        replaceHtml(policy, pair[0], pair[1]);
      });
    }
  }

  function runOkwdSitefix() {
    normalizeJapaneseCopy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOkwdSitefix);
  } else {
    runOkwdSitefix();
  }
  window.addEventListener('pageshow', runOkwdSitefix);
})();
